export enum StatisticsStatusUserAction {
    WAITING = 'WAITING',
    VALIDATED = 'VALIDATED',
    INVALIDATED = 'INVALIDATED',
}

export enum StatisticsStatusAutomaticAction {
    OUTDATED = 'OUTDATED',
}

export type StatisticsStatus = StatisticsStatusUserAction | StatisticsStatusAutomaticAction;
